/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * pinned {boolean} Pin the column
 * align {string} Column content alignment
 */
export default [
  {
    id: 1,
    label: 'Teacher Name',
    field_name: 'teacher_name',
    source_field: 'teacher_name',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'School Name',
    field_name: 'school_name',
    source_field: 'school_name',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Classes',
    field_name: 'class_count',
    source_field: 'class_count',
    showColumn: true,
    align: 'center',
  },
  {
    id: 4,
    label: 'Students',
    field_name: 'student_count',
    source_field: 'student_count',
    showColumn: true,
    align: 'center',
  },
  {
    id: 5,
    label: 'Last Login',
    field_name: 'last_login',
    source_field: 'last_login',
    showColumn: true,
  },
];
